/**
 * Calcula IVA (Chile 19%) o IGV (Perú 18%) sobre un monto neto.
 * Base normativa: DL 825 Chile, TUO IGV Perú.
 * Respaldado por IFRS 15 para reconocimiento neto de impuesto.
 *
 * @param {number} neto - Monto neto sin impuesto
 * @param {string} pais - "Chile" | "Peru" | "Perú"
 * @param {boolean} exento - true para DTE tipo 34 y equivalentes (impuesto = 0)
 * @param {boolean} decimales - true para conservar 2 decimales (USD, UF). Default false (entero, CLP/PEN).
 * @returns {{ impuesto: number, total: number }}
 */
export const calcularImpuesto = (neto, pais, exento = false, decimales = false) => {
  if (exento || !neto) return { impuesto: 0, total: neto || 0 };
  const tasa = pais === "Chile" ? 0.19 : 0.18;
  const impuesto = decimales ? Math.round(neto * tasa * 100) / 100 : Math.round(neto * tasa);
  const total = decimales ? Math.round((neto + impuesto) * 100) / 100 : neto + impuesto;
  return { impuesto, total };
};

/**
 * Extrae el monto neto desde un total con impuesto incluido.
 * Inverso de calcularImpuesto.
 * @param {number} total - Monto total con impuesto
 * @param {string} pais - "Chile" | "Peru"
 * @param {boolean} exento - Si true, neto = total
 * @returns {{ neto: number, impuesto: number }}
 */
export const extraerNeto = (total, pais, exento = false) => {
  if (exento || !total) return { neto: total || 0, impuesto: 0 };
  const tasa = pais === "Chile" ? 0.19 : 0.18;
  const neto = Math.round(total / (1 + tasa));
  const impuesto = total - neto;
  return { neto, impuesto };
};
